export default "__VITE_ASSET__B8t_eDHN__"